<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
    <b-card>
          <div slot="header">
            <strong>Claim Wise Listing</strong>
           <div class="card-header-actions" >                
             
            </div>
          </div>
            <b-row class="mb-1">          

                <b-col md="6" class="my-1">
                    <b-col sm="12" >
                   <b-form-group label="Delivery Agent"  label-size="sm"
                      :label-cols="3" >                   
                      <v-select id="mySelect" v-model="selectedagent" :options="this.data1" @input="getclaimwisecount" placeholder="Search" name="selectedagent" v-validate="'required'" :class="{ danger: errors.has('selectedagent') }">
                      </v-select>
                     <!--  <span v-show="errors.has('selectedagent')" class="danger" style="color:red">
                          {{ errors.first('selectedagent') }}
                      </span>  -->   
                    </b-form-group> 
                    </b-col>   
                </b-col> 

                  <b-col sm="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
                <!-- <b-col md="6" class="my-1">
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="pendingreport"> Search</b-button>
                 &nbsp;&nbsp;&nbsp;
                  
               </b-form-group>
             </b-col> -->
                 
              
              </b-row>
       <!--        <b-row >
             <b-col sm="4" class="my-1">
              <b-col sm="12" >
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              </b-col>
            </b-row> -->
            
           
               <div id="overlay" >
             <div class="loader"></div>
           </div>

 
             <b-row>
              <b-col sm="12" class="text-right">
                <!-- <b-button v-if="this.total_row_product >0"  @click="downloadCSV" variant="primary" size="md" >Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
              </b-col> 
          </b-row>

        <b-col sm="12" >
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>
             <template slot="action" slot-scope="row">
              <div v-if="row.item.reverse_bookingpendingshipment_count !=0 && row.item.reverse_bookingpendingshipment_count !=null && row.item.reverse_bookingpendingshipment_count !='undefined'">
                
              <b-button v-b-tooltip.hover title="Reverse Count Listing" size="sm" @click="claimwisedetails(row.item)" style="background: #b0c4de !important;color: #000 !important;" class="mr-1">
                    View
                  </b-button>
              </div>
              <div v-else>
                <span style="color:red"> No Shipments </span>
              </div>
             </template>
          </b-table>
        </b-col>
          <b-col md="12" class="my-1 " >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>   

          <!-- Reverse count Listing -->
           <b-modal size="md" v-model="showReverse"  ok-only  >
          <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Reverse Count Listing</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" v-if="listing.reverse_bookingpendingshipment_count != null && listing.reverse_bookingpendingshipment_count !=0" v-for="listing in ofd_listing">
            <b-card :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{listing.reverse_bookingpendingshipment_count}}</div>
                <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div>
              </b-card-body>
              <div slot="footer">
               <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showReversepickupdetails(listing.locality_id)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>
         

       </b-modal> 

             <b-modal v-model="reversecountdetails"   ok-only @hide="resetallshipmentsbystatus" size="lg">
                     <div class="card" v-for="(reverse, key, index) in reversecountdetail" >
      <!-- {{reverse}} -->
      <div class="card-header">
                  <div>
                   <code>{{(key+1)}}]  </code><strong>Shipment Id: </strong>{{ reverse.shippingid }}
                      <div class="card-header-actions">
                        <b-badge variant="danger" class="mr-4">{{ reverse.deliverystatus }} </b-badge>                     
                      </div>
                  </div>
        </div>
      <div class="card-body">     
       <div class="row mb-4">  
        <div class="col sm-12-4">
           <div><strong>{{ reverse.pickuplocationname }}</strong></div>
            <div><strong>Address :</strong>{{ reverse.pickuplocationaddress }}</div>    <div><strong>Hub ID:</strong> {{ reverse.hub_id }}</div>
            <div><strong>Lat Long:</strong> {{ reverse.pickuplonglat }}</div> 
           <!--  <div><strong>Handovertohub:</strong> <code>{{ reverse.handovertohub }}</code></div> -->
            <div><strong>Pickup Type:</strong> <code>{{ reverse.pickuptype }}</code></div> 

        </div>
         <div class="col-sm-4">
                        <div><strong>Poc Name :</strong>{{ reverse.pocname }}</div>                       
                        <div><strong>Shipment Status :</strong>{{ reverse.shipmentstatus }}</div>
                       
                        <div><strong>Vendor Name:</strong> {{ reverse.vendor_name }}</div>
                         <div><strong>OrderFlow:</strong> {{ reverse.orderflow }}</div>
                          <div><strong>Modified Date:</strong> {{ reverse.lastmodifieddate }}</div>
                     </div> 

      </div>
    </div>
     </div>

      </b-modal>
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'claimwise_listing', 
  data: function() {
    return {
        name: 'claimwise_listing',
        isBusy: false,           
        items:[],
        grandtotal:0,
        data1:[],
        fields: [
            { key: 'deliveryagentmasterid', label: 'ID' },
            { key: 'rider_name', label: 'Delivery Agent'},
            { key: 'reverse_bookingpendingshipment_count', label: 'Reverse Count'},
            { key: 'action', label: 'Action'},
          
              
              // { key: 'collectable_value', label: 'Deposit Amount'},
              // { key: 'pending_amount', label: ' Cod Pending  Amount '},
              // { key: 'payment_mode_status', label: 'Payment Mode'}  ,
              // { key: 'receipt_no', label: 'Receipt No'} ,
              // { key: 'remark', label: 'Remark'}  ,
              // { key: 'action', label: 'Date',sortable: true}  ,
              
                                         
         ], 
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        filter: null,
        currenthubidselct:'',
        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        selectedagent:'',
        showReverse:false,
        reversecountdetails:false,
         ofd_listing:[],
         reversecountdetail:[],

        // showValues:false
    }
  },
  created: function() {  
    this.displaydata();
    this.getclaimwisecount();
    
  },
 
  methods: {
    getclaimwisecount:function(){
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       // this.showValues=true;
      this.isBusy = true;
       var deliveryagentid=(this.selectedagent!=null)? this.selectedagent:"";


       if(this.selectedagent!='' &&  this.selectedagent!=null){

       const claimObj = {
        deliveryagentmasterid:this.selectedagent.key,
      }
      // console.log("ifObj",pendingObj);
  
    

      // const reportObj={},
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getclaimwisebookingpendingcount`, claimObj)
        .then((result) => {
          // this.agentmaster = result.body;
          // console.log("result",result);
           if (result.body.returnmsg === 'Successful') {
             // this.currentPage=1;
             this.items  = result.body.returnvalue;
             // this.grandtotal= result.body.returnvalue[0].grandtotal;

             // console.log("tthis.grandtotal ",this.grandtotal );
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
             // this.grandtotal=0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      }else{


        const claimObj = {}
      // console.log("ifObj",pendingObj);
  
    

      // const reportObj={},
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getclaimwisebookingpendingcount`, claimObj)
        .then((result) => {
          // this.agentmaster = result.body;
          // console.log("result",result);
           if (result.body.returnmsg === 'Successful') {
             // this.currentPage=1;
             this.items  = result.body.returnvalue;
              // this.grandtotal= result.body.returnvalue[0].grandtotal;
             // console.log("this.items ",this.grandtotal );
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
              // this.grandtotal=0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      }

    },
     claimwisedetails: function(value) {
    
      // alert(value.sdd_ndd_type);
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // return false;
      
      var Obj = {
         deliveryagentmasterid:value.deliveryagentmasterid,
         shipmentstatus:'ofd',
        sdd_ndd_type:'NDD',
      };  
 
   this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/localitywisecount`,
          Obj
        ).then(results => {
          // console.log("localitywisecount",results);
          if (results.body.message.toLowerCase() === "success") {
              this.showReverse =! this.showReverse;
           this.ofd_listing=results.body.data.shipment_list;
           // console.log("OfdListing",this.ofd_listing);
            
            
           
          } 
          else {
          
            this.ofd_listing=[];
              this.showReverse =! this.showReverse;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    
      
      
    },
    showReversepickupdetails:function(loc_id){
      // alert(loc_id);
        // this.reversecountdetails =! this.reversecountdetails;
            const reverseObj={
             locality_id:loc_id
        };
              this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getshipmentdetailsforreversebookingpending`,
          reverseObj
        ).then(results => {
          // console.log("Result",results);         
            // alert("in");
          // this.showReversecount=true;
          this.reversecountdetail=results.body.returnvalue;
          this.reversecountdetails =! this.reversecountdetails;
          // console.log("Reverse Count",this.reversecountdetail);
            
        }).catch(ex => {
          // alert("else");
          console.log("error", ex);
        });

    },
     downloadCSV: function() {
       document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
          var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
          };

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdatewisependingreportofridercsv`,csvObj)
        .then(result => {
         // console.log(result.url);
            document.getElementById("overlay").style.display = "none";
         if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Ur Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       });  
       }
       else
       {
        alert("Can not Download");
        // this.$fire({
        //           text:"Can not Download",
        //           type: "error",
        //           timer: 30000
        //         });  
       }
        //window.location.href =result.url;
        });

        
    },


    displaydata: function () {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        const deliveryagentobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          isactive: '1',
           hub_id:`${userInfo.pickuplocationmasterid}`,
        }
  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagentobj)
  .then(result => {
            this.data1 = result.body;          
            var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentfirstname+ '  '+srData.deliveryagentlastname+ ' - '+srData.deliveryagentmasterid
                });
              });
              this.data1 = data;
              this.data1.unshift({"label": "All", "key": 0});

        }).catch(ex => {
            console.log('error-----', ex)
        });
    }
    
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+' : '+ " " + strTime;
      }
    }
  }
 
};
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

   #mySelect  {
   width: 230px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
